import { DynFormSectionType } from "./dyn-form-section.enum"
import { DynFormSection, DynFormSectionBase } from "./dyn-form-section.model"


export class DynFormBase {

    id!: number
    name!: string
    template!: boolean
    procedureFormId!: number
    sections: DynFormSection[] = []


    constructor() {}

    sectionsByType(type: DynFormSectionType): DynFormSection[] {
        return this.sections.filter(s => s.type == type.valueOf())
    }

    static from (dynForm: DynForm): DynFormBase {
        let current = new DynFormBase()
        Object.assign(current, dynForm)

        current.sections = []

        dynForm.sections.forEach(s => {
            current.sections.push(DynFormSectionBase.from(s))
            current.sections = current.sections.sort(DynFormSectionBase.sortFn)
        })

        return current
    }

}

export interface DynForm extends DynFormBase { }